var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingProjectProps || _vm.isResolvingMiddleware)?_c('BasePageSpinner'):(!_vm.selectedPlace)?_c('DisabledWidgetOnboarding'):_c('RouterView')}
var staticRenderFns = []

export { render, staticRenderFns }